import { GetStaticPaths, GetStaticProps } from 'next'
import { getPost, getSortedPosts, Post, serializePostContent } from '../../utils/blog'
import React from 'react'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { getServerSideTranslations } from '../../utils/i18n_server'
import { MDXRemote } from 'next-mdx-remote'
import { useRouter } from 'next/router'
import { FieldDetailsMiniLoader } from '../../components/FieldDetailsMini'
import { PageHead } from '../../components/PageHead'
import { format } from 'date-fns'
import { getDateFnsLocaleFromNextjsLocale } from '../../utils/time'
import { PoolLayout } from '@/components/pools/PoolLayout'
import { getPoolPageLayout, NextPageWithLayout } from '../../components/layouts'

export const getStaticPaths: GetStaticPaths = async ({ locales, defaultLocale }) => {
    const posts = getSortedPosts()
    const paths = posts.flatMap((post) =>
        (locales ?? [defaultLocale] ?? []).map((locale) => ({
            params: {
                slug: post.slug,
            },
            locale,
        }))
    )

    return {
        paths,
        fallback: false,
    }
}

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
    const { slug } = params as any
    const translations = await getServerSideTranslations(locale, ['pools', 'home'])
    const post = await getPost(slug)
    const serializedMdx = await serializePostContent(post.content)

    return {
        props: {
            post,
            serializedMdx,
            ...translations,
        },
    }
}

const BlogSlugPage: NextPageWithLayout<{
    post: Post
    serializedMdx: any
}> = ({ post, serializedMdx }) => {
    const { locale } = useRouter()
    const components = { Typography, FieldDetailsMiniLoader }
    return (
        <>
            <PageHead title={`${post.data.seoTitle}`} description={post.data.abstract}></PageHead>
            <PoolLayout>
                <>
                    <div id="fb-root"></div>
                    <script
                        async
                        defer
                        crossOrigin="anonymous"
                        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v20.0&appId=1019225348887375"
                        nonce="KnH31Jfq"
                    ></script>
                    <Container maxWidth="lg">
                        {locale != post.data.locale && (
                            <Typography>Cet article n'est pas disponible dans votre langue</Typography>
                        )}
                        {!post.data.isPublished && (
                            <Typography color="orange">[dev] Cet article n'est pas encore publié</Typography>
                        )}

                        <Typography textAlign="center" variant="h1" fontWeight="600">
                            {post.data.title}
                        </Typography>
                        <Typography textAlign="center" variant="subtitle1">
                            {format(new Date(post.data.publishedOn), 'PPPP', {
                                locale: getDateFnsLocaleFromNextjsLocale(locale),
                            })}
                        </Typography>
                        <MDXRemote {...serializedMdx} components={components} />
                        <div
                            className="fb-comments"
                            data-href={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${post.slug}`}
                            data-width=""
                            data-numposts="5"
                        ></div>
                    </Container>
                </>
            </PoolLayout>
        </>
    )
}

BlogSlugPage.getPageLayout = getPoolPageLayout

export default BlogSlugPage
